import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {ConsultationReportGrid} from "./grid";
import {submitConsultationReport} from "../../../services/report/work";
import SelectInput from "../../system/select";
import {getAgentsList} from "../../../services/agent/agent";
import {getPersonsNameAndFamily} from "../../../services/profile/profile";
import {getFieldBranchesByFieldId} from "../../../services/branch/branch";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import FromToDateField from "../../system/fromToDateField";
import {getFields} from "../../../services/field/field";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import {downloadFile} from "../../../config";


export function ConsultationReportManagement() {

  const [consultationReport, setConsultationReport] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [gridRowCount, setGridRowCount] = useState(5);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);

  const [personId, setPersonId] = useState(null);
  const [agentId, setAgentId] = useState(null);
  const [fieldId, setFieldId] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [createdAtFrom, setCreatedAtFrom] = useState("");
  const [createdAtTo, setCreatedAtTo] = useState("");
  const [paidAtFrom, setPaidAtFrom] = useState("");
  const [paidAtTo, setPaidAtTo] = useState("");
  const [duration, setDuration] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(data, paginate) {
    const result = await submitConsultationReport(data, paginate);
    if (result.status === 200) {
      const {consultation_report, total_count} = result.data;
      setConsultationReport(consultation_report || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = () => {
    const data = {}
    if (personId) {
      data.person_id = personId;
    }

    if (agentId) {
      data.agent_id = agentId;
    }

    if (fieldId) {
      data.field_id = fieldId;
    }

    if (branchId) {
      data.branch_id = branchId;
    }

    if (createdAtFrom) {
      data.created_at_from = createdAtFrom;
    }

    if (createdAtTo) {
      data.created_at_to = createdAtTo;
    }

    if (paidAtFrom) {
      data.paid_at_from = paidAtFrom;
    }

    if (paidAtTo) {
      data.paid_at_to = paidAtTo;
    }

    if (duration) {
      data.duration = parseInt(duration);
    }

    if (status) {
      data.status = status;
    }

    return data
  };

  useEffect(() => {
    const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(data, paginate);
  }, [personId, agentId, branchId, fieldId, createdAtFrom, createdAtTo, paidAtFrom, paidAtTo, duration, status, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <div className="w-full">
      <Card className="pt-8 w-full">
        <CardHeader floated={true} shadow={false} className="rounded-none w-full">
          <div className="mb-8 flex items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">گزارش مشاوره‌ها</Typography>
          </div>

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">

          <div className="grid grid-cols-1 gap-4 mb-8 md:grid-cols-3 xxl:grid-cols-3">

            <div className="flex flex-col">
              <SelectInput
                label={"کاربر"}
                defaultValue={personId}
                refreshSignal={personId}
                // multiselect={false}
                autoLoadService={getPersonsNameAndFamily}
                autoLoadRender={({name, family}) => {
                  return name + " " + family
                }}
                onChange={setPersonId}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={"مباشر"}
                defaultValue={agentId}
                refreshSignal={agentId}
                // multiselect={false}
                autoLoadService={getAgentsList}
                autoLoadRender={({name, family}) => {
                  return name + " " + family
                }}
                onChange={setAgentId}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={"رشته"}
                defaultValue={fieldId}
                autoLoadService={getFields}
                onChange={setFieldId}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={"گرایش"}
                defaultValue={branchId}
                refreshSignal={fieldId}
                autoLoadService={getFieldBranchesByFieldId}
                autoLoadServiceData={fieldId}
                autoLoadRender={({title}) => {
                  return title
                }}
                onChange={setBranchId}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={"مدت"}
                options={[
                  {
                    "id": 15,
                    "title": persianNumberFormat("15")
                  },
                  {
                    "id": 20,
                    "title": persianNumberFormat("20")
                  },
                  {
                    "id": 25,
                    "title": persianNumberFormat("25")
                  },
                  {
                    "id": 30,
                    "title": persianNumberFormat("30")
                  },
                  {
                    "id": 35,
                    "title": persianNumberFormat("35")
                  },
                  {
                    "id": 40,
                    "title": persianNumberFormat("40")
                  },
                  {
                    "id": 45,
                    "title": persianNumberFormat("45")
                  },
                  {
                    "id": 50,
                    "title": persianNumberFormat("50")
                  },
                  {
                    "id": 55,
                    "title": persianNumberFormat("55")
                  },
                  {
                    "id": 60,
                    "title": persianNumberFormat("60")
                  },
                ]}
                onChange={setDuration}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={"وضعیت"}
                options={[
                  {
                    "id": 'payment',
                    "title": "درحال انجام"
                  },
                  {
                    "id": "waiting",
                    "title": "در انتظار تسویه"
                  },
                  {
                    "id": "finish",
                    "title": "اتمام خدمت"
                  },
                ]}
                onChange={setStatus}
              />
            </div>

          </div>

          <div className="flex flex-col md:flex-row">

            <div className="flex flex-row w-1/2 pb-4 mb-4 md:flex-col">
              <FromToDateField
                className="w-full"
                fromDate={createdAtFrom}
                setFromDate={setCreatedAtFrom}
                toDate={createdAtTo}
                setToDate={setCreatedAtTo}
                label="ایجاد"
              />
            </div>

            <div className="flex flex-col w-1/2 mb-4 md:flex-col">
              <FromToDateField
                className="w-full"
                fromDate={paidAtFrom}
                setFromDate={setPaidAtFrom}
                toDate={paidAtTo}
                setToDate={setPaidAtTo}
                label="پرداخت"
              />
            </div>

          </div>

          <div className="flex flex-row justify-between">
            <Button variant="gradient" color="gray" onClick={() => {
              setPersonId(null)
              setAgentId(null)
              setFieldId(null)
              setBranchId(null)
              setCreatedAtFrom(null)
              setCreatedAtTo(null)
              setPaidAtFrom(null)
              setPaidAtTo(null)
              setDuration(null);
              setStatus(null);
            }} className="ml-1">
              <span>حذف فیلتر</span>
            </Button>

            {consultationReport.length > 0 &&
              <Button size="sm" variant="outlined" onClick={() => {
                const data = filter();
                downloadFile("consultation_report_excel", data, "consultations")
              }}>
                خروجی اکسل
              </Button>
            }
          </div>


          <ConsultationReportGrid
            consultationReport={consultationReport}
            setSortBy={setSortBy}
            sortType={sortType}
            setSortType={setSortType}
          />
        </CardBody>
        <CardFooterPaginator
          active={gridCurrentPage}
          setActive={setGridCurrentPage}
          totalRows={gridTotalRowCount}
          rowsCount={gridRowCount}
          setRowsCount={setGridRowCount}
          from={from}
          to={to}
        />
      </Card>
    </div>
  );
}